export default function homeFeaturesScroll(node: HTMLElement) {
  const scrollContainer = node.querySelector<HTMLElement>(
    '.homeFeatures__inner',
  );
  const circles = node.querySelectorAll<HTMLElement>(
    '.homeFeatures__scrollIndicatorCircle',
  );

  if (!scrollContainer || circles.length === 0) {
    return;
  }

  const updateActiveCircle = () => {
    // Calculate which item is currently in the center of the viewport
    const scrollLeft = scrollContainer.scrollLeft;
    const clientWidth = scrollContainer.clientWidth;
    const scrollWidth = scrollContainer.scrollWidth;

    // Find the center point of the visible area
    const centerPoint = scrollLeft + clientWidth / 2;

    // Calculate scroll progress (0 to 1)
    const progress = centerPoint / scrollWidth;

    // Determine active index (0, 1, or 2)
    const activeIndex = Math.min(
      Math.floor(progress * circles.length),
      circles.length - 1,
    );

    // Update active class on circles
    circles.forEach((circle, index) => {
      if (index === activeIndex) {
        circle.classList.add('homeFeatures__scrollIndicatorCircle--active');
      } else {
        circle.classList.remove('homeFeatures__scrollIndicatorCircle--active');
      }
    });
  };

  // Listen to scroll events
  scrollContainer.addEventListener('scroll', updateActiveCircle, {
    passive: true,
  });

  // Set initial active state
  updateActiveCircle();
}
